package com.schoolconnect.app.feature.exams

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember

@Composable
fun ExamsFeatureRoute(
    onBack: () -> Unit,
    shellRoleCode: String = "",
    shellSchoolLabel: String = "iConnect.School",
    onChangeRole: () -> Unit = onBack,
    onLogout: () -> Unit = {}
) {
    val viewModel = remember { ExamsViewModel() }
    val uiState by viewModel.uiState.collectAsState()

    DisposableEffect(viewModel) {
        onDispose { viewModel.clear() }
    }

    ExamsScreen(
        state = uiState,
        onEvent = viewModel::onEvent,
        onBack = onBack,
        shellRoleCode = shellRoleCode,
        shellSchoolLabel = shellSchoolLabel,
        onChangeRole = onChangeRole,
        onLogout = onLogout
    )
}
